import React from 'react';
import { StarIcon } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    quote: 'Después de leer el programa entendí por qué mi mente nunca descansaba.',
    author: 'Laura M.',
    age: '34 años'
  }, {
    quote: 'Las explicaciones son simples pero muy poderosas.',
    author: 'Carlos R.',
    age: '41 años'
  }, {
    quote: 'Me ayudó a dejar de reaccionar a todo.',
    author: 'Andrea G.',
    age: '28 años'
  }, {
    quote: 'Llevaba años con ansiedad y sobrepensamiento. Este programa me dio herramientas que realmente puedo usar cada día.',
    author: 'Roberto S.',
    age: '38 años'
  }, {
    quote: 'Pensé que era normal vivir con la mente acelerada. Ahora entiendo que hay otra forma de vivir.',
    author: 'Valentina P.',
    age: '29 años'
  }];
  return <section className="bg-[#faf6f0] text-gray-900 py-20 px-4" data-id="element-208">
      <div className="max-w-6xl mx-auto" data-id="element-209">
        <h2 className="font-oswald text-4xl md:text-5xl font-bold text-center mb-16 uppercase tracking-tight text-[#2a1f14]" data-id="element-210">
          Lo que dicen quienes ya lo probaron
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-211">
          {testimonials.map((t, i) => <div key={i} className={`bg-white p-8 rounded-xl shadow-lg border border-gray-100 flex flex-col justify-between ${i === 3 ? 'md:col-span-2 lg:col-span-1' : ''} ${i === 4 ? 'md:col-span-2 lg:col-span-2' : ''}`} data-id="element-212">
              <div data-id="element-213">
                <div className="flex gap-1 mb-4" data-id="element-214">
                  {[...Array(5)].map((_, j) => <StarIcon key={j} className="w-5 h-5 fill-[#c9a96e] text-[#c9a96e]" data-id="element-215" />)}
                </div>
                <p className="font-opensans text-lg md:text-xl text-gray-800 italic font-semibold mb-6" data-id="element-216">
                  "{t.quote}"
                </p>
              </div>
              <div className="border-t border-gray-100 pt-4 mt-auto" data-id="element-217">
                <p className="font-oswald text-xl font-bold text-[#2a1f14] uppercase" data-id="element-218">
                  — {t.author}
                </p>
                <p className="font-opensans text-sm text-gray-500" data-id="element-219">{t.age}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}